import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/韩漫', label: '韩漫' },
    { to: '/category/日漫', label: '日漫' },
    { to: '/category/国漫', label: '国漫' },
    { to: '/about', label: '关于我们' },
  ];

  const navbarBg = isHome && !scrolled
    ? 'bg-transparent'
    : 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70';

  const textColor = isHome && !scrolled
    ? 'text-white'
    : 'text-foreground-800';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${navbarBg}`}>
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className={`flex items-center gap-2 font-heading font-bold text-xl whitespace-nowrap ${textColor}`}>
            <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">
              蕉
            </span>
            香蕉漫画
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-3 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors ${
                  location.pathname === link.to
                    ? isHome && !scrolled
                      ? 'bg-white/20 text-white'
                      : 'bg-primary-50 text-primary-700'
                    : isHome && !scrolled
                      ? 'text-white/80 hover:text-white hover:bg-white/10'
                      : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg ${textColor}`}
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-3">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`block px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                location.pathname === link.to
                  ? 'bg-primary-50 text-primary-700'
                  : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>
      )}
    </nav>
  );
}